import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useLocation } from 'react-router-dom';
import LoadingBar from "react-top-loading-bar";
import {
  CallLogType,
  ColumnSelectionTableType,
  ExportTableType,
  PaginationSettings,
  topLoaderProgress
} from "../../configs";
import { useAppSelector,  VRIAppStateType} from "../../core";
import {
  CallLogTableDataWeb,
  CommonFilter,
  ModalCallSummary,
  Searchbar
} from "../../features";
import { CallLogInfoBox } from "../../features/Common/Components/CallLogInfoBox";
import { ColumnSelectionsModel } from "../../models";
import {
  CallLogPagedResponseModel,
  CallSummaryResponseModel
} from "../../models/api/Call";
import { ApiSchemaFilter } from "../../models/api/filter";
import { useFunctionalityCallLog, useFunctionalityCallSummary, useFunctionalityColumnSelections } from "../hooks";
import { useFunctionalityCallLogColumns } from "../hooks/functionalityCallLogColumns";

export function PageOverflowCall(): JSX.Element {
  const [loaderProgress, setLoaderProgress] = React.useState(0);
  const [tableType, setTableType] = React.useState("search");
  const [show, setShow] = React.useState(false);
  const [isShowCommonFilter, setIsShowCommonFilter] = useState<boolean>(false);
  const [callSummaryData, setCallSummaryData] =
    React.useState<CallSummaryResponseModel>();
  const [pageIndex, setPageIndex] = useState(
    PaginationSettings.initialPageIndex
  );
  const [pageSize, setPageSize] = useState(PaginationSettings.initialPageSize);
  const [searchText, setSearchText] = useState<string>("");
  const [callLogData, setCallLogData] =
    useState<CallLogPagedResponseModel>(Object);
  const [pagedCallListCount, setPagedCallListCount] = useState(0);
  const location = useLocation<{ callId: string }>();
  const callId = location.state?.callId;
  const { LoadById } = useFunctionalityCallSummary();

  let initialFilterData: ApiSchemaFilter = {
    filterQueries: [],
    sortQuery: {}
  };
  const [filterData, setFilterData] = useState<ApiSchemaFilter>(initialFilterData);
  const [filterDataChange, setFilterDataChange] = useState<number>(0);

  const { LoadCallLog } = useFunctionalityCallLog({
    pageSize: pageSize,
    pageNo: pageIndex,
    callLogType: CallLogType.OverflowCall,
    setLoaderProgress,
    filterData,
  });

  useEffect(() => {
    if (callId) {
      setLoaderProgress(topLoaderProgress.start);
      // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>> LoadbyId from OverflowCallPage");
      LoadById(callId).then((data) => {
        setLoaderProgress(topLoaderProgress.complete);
        setCallSummaryData(data);
        setShow(true);
      });
    }
    setLoaderProgress(topLoaderProgress.start);
    LoadCallLog().then((r) => {
      setLoaderProgress(topLoaderProgress.complete);

      if (r?.data) setCallLogData(r?.data);
      if (r?.data) setPagedCallListCount(r?.data.totalCount);
    });
  }, [pageSize, pageIndex, filterData]);
  const onChangePageIndex = (index: number) => {
    setPageIndex(index);
  };
  const onChangePageSize = (size: number) => {
    setPageSize(size);
  };
  const currentSession = useAppSelector((state: VRIAppStateType) => ({
    userRole: state.auth.profile?.userRole,
  }));

  const [columnSelection, setColumnSelection] = useState<ColumnSelectionsModel[]>([])
  const [columnSelectionModalShow, setColumnSelectionModalShow] = React.useState(false);
  const { LoadColumnSelections } = useFunctionalityColumnSelections({
    type: ColumnSelectionTableType.OverflowCall
  });

  useEffect(() => {
    LoadColumnSelections().then((r) => {
      if (r?.data) setColumnSelection(r?.data);
    });
  }, [])

  const { callLogColumn } = useFunctionalityCallLogColumns({
    userRole: currentSession.userRole ?? "",
    setShow: setShow,
    setCallSummaryData: setCallSummaryData,
    setLoaderProgress: setLoaderProgress,
    callLogType: CallLogType.OverflowCall,
    columnSelection: columnSelection,
  });

  const handleSearch = (e: any) => {
    ReactDOM.unstable_batchedUpdates(() => {
      setSearchText(e.target.value);
      setPageIndex(1);
    });
  };
  return (
    <>
      <LoadingBar
        progress={loaderProgress}
        onLoaderFinished={() => setLoaderProgress(0)}
      />
      <h4 className="my-3 font-weight-light">
        Overflow Call
      </h4>
      <div className="call-log-page ">
        <div className="row">
          <div className="col-12">
            <Searchbar
              showFilter={true}
              showExportOptions={true}
              filterPanel={"commonFilterPanel"}
              handleSearch={handleSearch}
              searchText={searchText}
              columnSelectionModalShow={columnSelectionModalShow}
              setColumnSelectionModalShow={setColumnSelectionModalShow}
              columnSelection={columnSelection}
              setColumnSelection={setColumnSelection}
              showAutoRefresh={true}
              tableType={ExportTableType.OverflowCall}
              downloadedFileName={'CallLog'}
              setLoaderProgress={setLoaderProgress}
              filterData={filterData}
              setIsShowCommonFilter={setIsShowCommonFilter}
            />
          </div>
          {
            isShowCommonFilter && <CommonFilter
              setFilterData={setFilterData}
              setLoaderProgress={setLoaderProgress}
              setFilterDataChange={setFilterDataChange}
              pageName='callLogPage'
              setPageIndex={setPageIndex}
            />
          }

          <CallLogInfoBox
            callLogData={callLogData}
            userRole={currentSession.userRole ?? ""}
          />
          <CallLogTableDataWeb
            pagingKey="PageOverflowCall"
            loaderProgress={loaderProgress}
            pageHeader="Call Log"
            isPageEnabled={true}
            tableData={callLogData.callLogs}
            tableHeaders={callLogColumn}
            pageIndex={pageIndex}
            pageSize={pageSize}
            count={pagedCallListCount}
            searchText={searchText}
            filterDataChange={filterDataChange}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
            setCallSummaryData={setCallSummaryData}
            setLoaderProgress={setLoaderProgress}
            setShow={setShow}
          />
          <ModalCallSummary
            summary={callSummaryData}
            show={show}
            handleShow={setShow}
          />
        </div>
      </div>
    </>
  );
}
